import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import ActionCard from "../../components/dashboard/ActionCard";
import dashboardActionsCards from "../../utils/dashboard-actions";

const DashboardActions = () => {
  return (
    <Paper sx={{ width: "100%", mt: 5, mb: 2, p: 3 }}>
      <Typography variant="h5" sx={{ mb: 1 }}>
        Dashboard Actions
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: "#999" }}>
        Effortlessly handle invoice generation, adding new building, property or
        tenant, to keep your records up to date.
      </Typography>
      <Grid container spacing={3} sx={{ mb: 2 }}>
        {dashboardActionsCards.map((card, index) => (
          <ActionCard key={index} {...card} />
        ))}
      </Grid>
    </Paper>
  );
};

export default DashboardActions;
